import { Typography } from "@mui/material";

export default function Reviewers() {
  return <Typography>Admin Reviewers Page</Typography>;
}
